import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import styled from 'styled-components';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
  title?: string;
  chartData: { label: string; caption: string; value: number; color: string }[];
  size?: 'tiny' | 'small' | 'medium' | 'large';
  tooltip?: 'long' | 'short' | 'none';
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  title = '',
  chartData = [],
  size = 'large',
  tooltip = 'long'
}) => {
  const data = {
    labels: chartData ? chartData.map((item: { label: string }) => tooltip === 'long' ? `${item.label}` : '') : [],
    datasets: [
      {
        data: chartData
          ? chartData.map((item: { value: number }) => parseFloat(item.value.toFixed(2)))
          : [],
        backgroundColor: chartData ? chartData.map((item: { color: string }) => item.color) : [],
        borderWidth: 1,
        borderColor: '#fff',
        hoverBorderColor: '#000',
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: tooltip === 'none' ? false : true,
        callbacks: {
          label: function (tooltipItem: any) {
            return `${tooltipItem.formattedValue}%`;
          },
        },
      },
    },
    cutout: '60%',
    responsive: true,
  };

  return (
    <DoughnutContainer size={size}>
      <Doughnut data={data} options={options} />
      <DoughnutLabel size={size}>{title}</DoughnutLabel>
    </DoughnutContainer>
  );
};

export default DoughnutChart;

// Styled Components
const DoughnutContainer = styled.div<{ size: 'tiny' | 'small' | 'medium' | 'large' }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props =>
    props.size === 'tiny'
      ? '40px'
      : props.size === 'small'
        ? '70px'
        : props.size === 'large'
          ? '150px'
          : '110px'};
  height: ${props =>
    props.size === 'tiny'
      ? '40px'
      : props.size === 'small'
        ? '70px'
        : props.size === 'large'
          ? '150px'
          : '110px'};
`;

const DoughnutLabel = styled.div<{ size: 'tiny' | 'small' | 'medium' | 'large' }>`
  font-family: 'Poppins', sans-serif;
  font-size: ${props =>
    props.size === 'tiny'
      ? '10px'
      : props.size === 'small'
        ? '12px'
        : props.size === 'large'
          ? '28px'
          : '14px'};
  margin-top: 10px;
  text-align: center;
`;
